import { useContext, useReducer } from "react";
import { createContext } from "react"
import { Form as FinalForm } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { FormTitle } from "../componentes/layout/form/FormTitle";
import { formReducer, FORM_ACTION_TYPES } from "../componentes/layout/form/formReducer";


const FormContext = createContext({})

export function FormProvider({children, idForm, tituloForm, formLimpo = false}) {
  const INITIAL_STATE = {
    conteudo: "lista",
    dados: {},
    lista: [],
    edicao: true,
    botoes: [],
    submitFunction: undefined
  }
  const [state, dispach] = useReducer(formReducer, INITIAL_STATE)

  function addBotoes(botoes, substituir){
    //Usa setTimeout para evitar submit automático ao clicar em botões anteriores
    setTimeout(() => {
      dispach({
        type: FORM_ACTION_TYPES.ADD_BOTOES,
        payload: {
          substituir, 
          botoes
        }
      })
    }, 50);
  }

  function removeBotoes(){
    dispach({
      type: FORM_ACTION_TYPES.REMOVE_BOTOES
    })
  }

  function setSubmit(submit){
    dispach({
      type: FORM_ACTION_TYPES.SET_SUBMIT,
      payload: submit
    })
  }

  function carregaForm(dados = {}, edicao = true, reset){
    //Usa o reset para garantir que vai limpar os dados
    reset()
    //Por padrão, sempre manda id_empresa
    dispach({
      type: FORM_ACTION_TYPES.CARREGA_FORM,
      payload: {
        dados, 
        edicao
      }
    })
  }

  function carregaLista(lista = []){
    dispach({
      type: FORM_ACTION_TYPES.CARREGA_LISTA,
      payload: lista
    })
  }

  //Função obrigatória no FinalForm
  async function handleSubmit(values){
    if(state.submitFunction){
      await state.submitFunction(values)
    }
  }

  return (
    <FinalForm
        onSubmit={handleSubmit}
        initialValues={state.dados}
        destroyOnUnregister
        mutators={{
            ...arrayMutators, 
        }}
        render={({ handleSubmit, form, values }) => {
          return (
            <form id={idForm} onSubmit={handleSubmit}>
              <FormContext.Provider value={{ 
                idForm, 
                state,
                campos: values,
                addBotoes, 
                carregaForm: (dados, edicao) => { carregaForm(dados, edicao, form.reset)},
                carregaLista,
                removeBotoes, 
                setSubmit,
                alterarCampo: form.change,
                formSubmit: form.submit
              }}>
                {(!formLimpo ? <FormTitle idForm={idForm} titulo={tituloForm} /> : null)}
                <section className={(!formLimpo ? "content" : "")}>
                  {children}
                </section>
              </FormContext.Provider>
            </form>
          )
        }}
    />
  )
}

export function useFormSistema() {
    const context = useContext(FormContext)

    return context;
}